module.exports = __webpack_public_path__ + "img/SkeletonIcon.63974171.svg";